import React from "react";

// Note body with its EN ⇄ ZH translation: the version matching the current
// UI language comes first, the other one follows in a muted block.
export function NoteText({ n, lang, className = "", testid }) {
  const tr = n?.translation;
  if (!tr) return <div className={`whitespace-pre-wrap ${className}`} data-testid={testid}>{n?.text}</div>;
  const translationFirst = n.translation_lang === lang;
  const [first, second] = translationFirst ? [tr, n.text] : [n.text, tr];
  return (
    <div className={`space-y-1 ${className}`} data-testid={testid}>
      <div className="whitespace-pre-wrap" data-testid={testid ? `${testid}-primary` : undefined}>{first}</div>
      <div className="text-xs text-slate-500 whitespace-pre-wrap border-l-2 border-slate-300 pl-2" data-testid={testid ? `${testid}-secondary` : undefined}>
        🌐 {second}
      </div>
    </div>
  );
}
